import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"disabled":_vm.isDisabled,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(!_vm.isDisabled)?_c('BaseButton',_vm._g(_vm._b({attrs:{"icon":"","loading":_vm.isLoading,"data-testid":"download-stamped-pdf-base-button"},on:{"click":_vm.downloadPdf}},'BaseButton',attrs,false),on),[_c(VIcon,[_vm._v("mdi-stamper")])],1):_vm._e()]}}])},[_c('span',{staticClass:"ws-pre-wrap"},[_vm._v(_vm._s(_vm.$t('forms.stampedPdf.downloadTooltip')))])])}
var staticRenderFns = []

export { render, staticRenderFns }